<mat-card
  [ngClass]="isContainerExpanded === true ? 'bg-lightwhite' : 'bg-lightgrey'"
>
  <mat-icon
    *ngIf="!isContainerExpanded"
    class="top-icon expand-more"
    (click)="onSectionExpand()"
    >expand_more</mat-icon
  >
  <mat-icon
    *ngIf="isContainerExpanded"
    class="top-icon expand-less"
    (click)="onSectionCollapse()"
    >expand_less</mat-icon
  >

  <mat-card-title [ngClass]="to.disabled ? 'text-disabled' : 'text-enabled'"
    >{{ sequence }}{{ to.label }}
  </mat-card-title>
  <mat-card-content *ngIf="isContainerExpanded">
    <ng-container #fieldComponent></ng-container>
  </mat-card-content>
</mat-card>
